import Immutable, { List, Map, OrderedMap, Record } from "immutable";

import range from "lodash/range";
import shuffle from "lodash/shuffle";
import keyBy from "lodash/keyBy";

import Player from "./Player";

export const VERSION = 3;

const keyify = player => player.shortName;

function randSeq() {
  return List(shuffle(range(10)));
}

function ident(x) {
  return x;
}

function revInds(arr) {
  if (!arr) {
    return null;
  }
  const ret = Array(arr.length);
  arr.forEach((x, i) => {
    ret[x] = i;
  });
  return ret;
}

function arraysToBoard(arrs) {
  const m = {};
  for (let r = 0; r < 10; r++) {
    for (let c = 0; c < 10; c++) {
      const name = arrs[r][c];
      if (name) {
        m[[r, c]] = name;
      }
    }
  }
  return m;
}

export const PICK_STATES = {
  INITIAL: 0,
  LIVE: 1,
  DONE: 2,
};

class Picks extends Record({
  counts: Map(),
  board: Map(),
  total: 0,
  players: OrderedMap(),
  awayNums: null,
  homeNums: null,
  gamekey: null,
  state: 0,
}) {
  addPlayer(player) {
    return this.set("players", this.players.set(keyify(player), player));
  }

  addPick(row, col, player) {
    if (!this.players.has(keyify(player))) {
      throw new Error("must addPlayer before adding pick");
    }
    return this.withMutations(picks => {
      picks.set("board", picks.board.set(String([row, col]), keyify(player)));
      picks.withUpdatedCounts();
    });
  }

  getPlayer(row, col) {
    const key = this.board.get(String([row, col]));
    return key ? this.players.get(key) : null;
  }

  winnerAt(scoreAway, scoreHome) {
    if (!this.awayRevInds) {
      this.awayRevInds = revInds(this.awayNums);
    }
    if (!this.homeRevInds) {
      this.homeRevInds = revInds(this.homeNums);
    }
    return this.getPlayer(this.awayRevInds[scoreAway % 10], this.homeRevInds[scoreHome % 10]);
  }

  removePick(row, col) {
    const player = this.getPlayer(row, col);
    if (!player) return this;
    return this.withMutations(picks => {
      picks.set("board", picks.board.delete(String([row, col])));
      picks.withUpdatedCounts();
    });
  }

  genNums() {
    let ret = this;
    if (!this.awayNums) {
      ret = ret.set("awayNums", randSeq());
    }
    if (!this.homeNums) {
      ret = ret.set("homeNums", randSeq());
    }
    return ret;
  }

  playerCount(player) {
    return this.counts.get(keyify(player), 0);
  }

  serialize() {
    return JSON.stringify(Object.assign(this.toJS(), { version: VERSION }));
  }

  withUpdatedCounts() {
    return this.withMutations(picks => {
      picks.set("total", picks.board.size);
      picks.set("counts", picks.board.countBy(ident));
    });
  }
}

export default Picks;

export function deserialize(str) {
  let obj;
  try {
    obj = JSON.parse(str);
  } catch (e) {
    return null;
  }

  if (!obj || !obj.version || obj.version !== VERSION) {
    return null;
  }
  delete obj.version;
  return fromJS(obj);
}

export function fromServerJSON(dataObj) {
  const obj = Object.assign({}, dataObj);
  // Server stores this as [['','','',...], [.....]] locally we store as a mapping
  obj.board = arraysToBoard(obj.board);
  if (obj.players === null) {
    obj.players = [];
  }
  return fromJS(obj);
}

export function fromJS(obj) {
  const players = Immutable.fromJS(keyBy(obj.players, "shortName"), function(key, value) {
    if (key === "") {
      return OrderedMap(value);
    }
    return new Player(value);
  });
  return Immutable.fromJS(obj, function(key, value) {
    switch (key) {
      case "":
        return new Picks(value);
      case "counts":
        return Map(value);
      case "board":
        return Map(value);
      case "total":
      case "gamekey":
      case "state":
        return value;
      case "players":
        return players;
      case "homeNums":
      case "awayNums":
        return List(value);
      default:
        console.error(`Deserialize error key=${key} value=${value}`);
    }
  }).withUpdatedCounts();
}



// WEBPACK FOOTER //
// ./src/Picks.js